<template>
  <div>
    <div>
      <el-form :inline="true" ref="form2" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="param.name" maxlength="200" style="width: 200px" @keyup.native.enter="list"></el-input>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="zi" label="汉字" width="100" show-overflow-tooltip/>
        <el-table-column prop="wubi" label="五笔" width="100" show-overflow-tooltip/>
        <el-table-column prop="bushou" label="部首" width="100" show-overflow-tooltip/>
        <el-table-column prop="bihua" label="笔画" width="100" show-overflow-tooltip/>
        <el-table-column prop="pinyin" label="拼音" width="500" show-overflow-tooltip/>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import global from '../components/Global'

export default {
  name: 'Hanzi',
  data () {
    return {
      tableData: [],
      param: {name: null}
    }
  },
  created () {
    // this.list()
  },
  methods: {
    list () {
      if (this.param.name === undefined || this.param.name === null) {
        this.$message.error('请输入查询条件。')
        return
      }
      this.tableData = []
      http.post(global.url0 + 'hanzi/like/', this.param).then(
        res => {
          let resStr = res.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Hanzi.vue